import { render } from "./CreateTeamPage.vue?vue&type=template&id=d5681d20&scoped=true"
import script from "./CreateTeamPage.vue?vue&type=script&lang=js"
export * from "./CreateTeamPage.vue?vue&type=script&lang=js"

import "./CreateTeamPage.vue?vue&type=style&index=0&id=d5681d20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5681d20"]])

export default __exports__